import { ModelTableView } from '@/assets/js/ModelView'
import * as C from '../list'

const journey = new ModelTableView([
	C.driver,
	C.vehicle,
	C.origin,
	C.destination,
	C.waypoint,
	C.departure,
	C.arrival,
	C.pax,
	C.supervisor,
	C.purpose,
	C.remarks,
	C.brief,
	C.debrief,
	C.phone,
	C.email,
	C.mapUrl,
	C.trackerUrl,
	C.gpxRouteUrl,
	C.gpxTrackUrl,
	C.webUrl,
	C.delay,
	C.ad,
	C.ed,
	C.sd,
	C.odometer,
	C.distance,
	C.state
]);

journey.visibleProperties([ "driver", "vehicle", "origin", "destination", "departure", "arrival" ]);
journey.sortBy("arrival", true);

export default journey;



// WEBPACK FOOTER //
// ./src/services/components/views/journey.js